"use client";

import * as React from "react";
import type { LegendProps } from "recharts";
import { ChartLegendToggleAll } from "./chart-legend-toggle-all";
import { cn } from "@/utils";

type LegendPayload = {
  dataKey?: string | number;
  value?: string;
  color?: string;
};

type ExploreChartLegendProps = Omit<LegendProps, "onClick"> & {
  lineKeys: string[];
  hidden: string[];
  onHiddenChange: React.Dispatch<React.SetStateAction<string[]>>;
  xAxisLabel?: string;
  onClick?: LegendProps["onClick"];
};

export function ExploreChartLegend({
  payload,
  lineKeys,
  hidden,
  onHiddenChange,
  xAxisLabel,
  onClick,
}: ExploreChartLegendProps) {
  if (!payload?.length) return null;

  return (
    <div className="flex w-full flex-col items-center gap-2 pt-1">
      {xAxisLabel ? (
        <p className="text-center text-[11px] text-white/55">{xAxisLabel}</p>
      ) : null}
      <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        {(payload as LegendPayload[]).map((entry) => {
          const key = String(entry.dataKey ?? entry.value);
          const inactive = hidden.includes(key);
          return (
            <li
              key={key}
              className={cn(
                "flex cursor-pointer items-center gap-2 text-sm transition-opacity",
                inactive && "opacity-40",
              )}
              onClick={(event) =>
                onClick?.(
                  {
                    ...event,
                    dataKey: entry.dataKey,
                    value: entry.value,
                  } as Parameters<NonNullable<LegendProps["onClick"]>>[0],
                  {} as Parameters<NonNullable<LegendProps["onClick"]>>[1],
                  {} as Parameters<NonNullable<LegendProps["onClick"]>>[2],
                )
              }
            >
              <span
                className="inline-block h-2.5 w-2.5 shrink-0 rotate-45"
                style={{ backgroundColor: entry.color }}
                aria-hidden
              />
              <span className="text-muted hover:text-white">{entry.value}</span>
            </li>
          );
        })}
      </ul>
      <ChartLegendToggleAll
        lineKeys={lineKeys}
        hidden={hidden}
        onHiddenChange={onHiddenChange}
      />
    </div>
  );
}

export default ExploreChartLegend;
